import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'place-container',
  templateUrl: './place-container.component.html',
  styleUrls: ['./place-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaceContainer extends StaticContainer {
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/place-container/place-container.component.ts